import React, { memo } from "react";
import { isEmpty } from "@swiggy-private/js-utils";
import { CalloutContainer, CalloutBubble, CalloutMessage } from "./styles";
import { DELIVERY_SECTION_CALLOUT_VARIANT } from "./constants";

interface DeliverySectionCalloutProps {
    message?: string;
    variant?: DELIVERY_SECTION_CALLOUT_VARIANT;
}

function DeliverySectionCallout({
    message,
    variant = DELIVERY_SECTION_CALLOUT_VARIANT.BOTTOM_PADDING,
}: DeliverySectionCalloutProps) {
    if (isEmpty(message)) {
        return null;
    }

    return (
        <CalloutContainer variant={variant}>
            <CalloutBubble>
                <CalloutMessage variant="V2.body3.neutral.regular">{message}</CalloutMessage>
            </CalloutBubble>
        </CalloutContainer>
    );
}

export default memo(DeliverySectionCallout);
